export const sm = () => (window.innerWidth < 576 ? true : false);
